/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Coil_Hydraulic_ChangeoverInputs */



/**
* | output |
* | --- |
* | "Changeover coil" |
*
* @param {Air_Handler_Unit_Coil_Hydraulic_ChangeoverInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_coil_hydraulic_changeover = /** @type {((inputs?: Air_Handler_Unit_Coil_Hydraulic_ChangeoverInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Coil_Hydraulic_ChangeoverInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Changeover coil")
	return /** @type {LocalizedString} */ ("Batterie Change Over")
});